import { ChangeDetectionStrategy, Component, Input, OnInit, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SafePipe } from '@bazis/shared/pipes/safe.pipe';
import { TranslocoModule } from '@jsverse/transloco';

@Component({
    selector: 'bazis-default-loader',
    templateUrl: './default-loader.component.html',
    imports: [CommonModule, TranslocoModule, SafePipe],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultLoaderComponent implements OnInit {
    readonly message = input<string>();

    readonly messageKey = input<string>();

    readonly theme = input<'light' | 'dark' | 'transparent'>('light');

    readonly centerX = input(25);

    readonly centerY = input(25);

    readonly radius = input(14);

    // inline - в потоке DOM
    // block - fixed
    // inner - absolute in other parent block
    readonly type = input<'inline' | 'block' | 'inner'>('inline');

    readonly cssClass = input<string>('');

    readonly loader = input<'spinner' | 'dots'>('spinner');

    readonly amountDots = input(5);

    ngOnInit(): void {}
}
